import PropTypes from 'prop-types';
import { Accent, Box } from '@nerdwallet/currency';
import styles from './impact-pyramid.module.less';

const PyramidLabel = ({
  children,
  color,
  backgroundColor,
  disableShadow,
  ...props
}) => (
  <Box className={disableShadow ? '' : styles.labelShadowWrapper}>
    <Box
      className={styles.labelBox}
      style={{ backgroundColor, color }}
      {...props}
    >
      <Accent size="small">{children}</Accent>
    </Box>
  </Box>
);

PyramidLabel.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  disableShadow: PropTypes.bool,
};

export default PyramidLabel;
